import React from 'react';
import InputField from 'shared/components/InputField';
import BestFitRegion from '../BestFitRegion';
import { ReactComponent as MapSearch } from 'assets/icons/map-search.svg';
import { ReactComponent as DeleteButton } from 'assets/icons/close_enclosed.svg';
import clsx from 'clsx';
import styles from '../CreateProductFlow.module.scss';
import { FieldProps, RawMaterialProps } from 'enums/RawMaterialEnums';
import hasErrorAndTouched from 'shared/utils/hasErrorAndTouched';
import { FormikProps } from 'formik';
import { Origin, rawMaterialPayload } from 'views/CreateProductFlow/CreateProductFlowInterfaces';

interface IngredientOriginFieldsProps {
  index: number;
  originIndex: number;
  isDisabled: boolean;
  formikProps: FormikProps<rawMaterialPayload>;
  fetchData: (params?: { 'input-field': string }) => void;
  showLocationModal: (
    index: number,
    type: string,
    selectedIndexData?: Origin[],
    selectedRecordIndex?: number,
    selectedRecordType?: string,
    selectedOriginIndex?: number
  ) => void;
  handleRemoveOrigins: (
    formikProps: FormikProps<rawMaterialPayload>,
    index: number,
    originIndex: number,
    type?: string
  ) => void;
}

const IngredientOriginFields: React.FC<IngredientOriginFieldsProps> = ({
  index,
  originIndex,
  isDisabled,
  formikProps,
  fetchData,
  showLocationModal,
  handleRemoveOrigins,
}) => {
  return (
    <div
      key={`${RawMaterialProps.ORIGINS}-${originIndex}`}
      className={styles.fieldRow}>
      <div className={styles.numberEmptyContainer}></div>
      <div className={styles.ingredientFieldContainer}></div>
      <div className={styles.bigFieldContainer}>
        <InputField
          name={`${RawMaterialProps.INGREDIENTS}[${index}].${RawMaterialProps.ORIGINS}[${originIndex}].${RawMaterialProps.INGREDIENT_ORIGIN}`}
          label={FieldProps.INGREDIENT_ORIGIN_PLACEHOLDER}
          placeholderstring={FieldProps.INGREDIENT_ORIGIN_PLACEHOLDER}
          disabled={isDisabled}
          suffix={
            <span
              onClick={() =>
                !isDisabled &&
                showLocationModal(
                  originIndex,
                  `${RawMaterialProps.INGREDIENTS}[${index}].${RawMaterialProps.ORIGINS}`,
                  formikProps?.values?.ingredients?.[index]?.origins,
                  index,
                  RawMaterialProps.INGREDIENTS,
                  originIndex
                )
              }>
              <MapSearch />
            </span>
          }
          onFocus={() =>
            showLocationModal(
              originIndex,
              `${RawMaterialProps.INGREDIENTS}[${index}].${RawMaterialProps.ORIGINS}`,
              formikProps?.values?.ingredients?.[index]?.origins,
              index,
              RawMaterialProps.INGREDIENTS,
              originIndex
            )
          }
        />
      </div>
      <div className={styles.bigFieldContainer}>
        <BestFitRegion
          label={FieldProps.INGREDIENT_REGION_PLACEHOLDER}
          placeholder={FieldProps.INGREDIENT_REGION_PLACEHOLDER}
          disabled={isDisabled}
          onFocus={() => {
            fetchData({
              'input-field': 'production region',
            });
          }}
          name={`${RawMaterialProps.INGREDIENTS}[${index}].${RawMaterialProps.ORIGINS}[${originIndex}].${RawMaterialProps.BEST_FIT_REGION}`}
          ingridientFieldName={`${RawMaterialProps.INGREDIENTS}[${index}].${FieldProps.INGREDIENT_NAME}`}
          errorMessageStyle={styles.errorMessage}
        />
      </div>
      <div className={styles.smallFieldContainer}>
        <InputField
          key={FieldProps.INGREDIENT_QUANTITY}
          name={`${RawMaterialProps.INGREDIENTS}[${index}].${RawMaterialProps.ORIGINS}[${originIndex}].${RawMaterialProps.ORIGIN_SHARE}`}
          label={FieldProps.INGREDIENT_ORIGIN_SHARE_PLACEHOLDER}
          placeholderstring={FieldProps.INGREDIENT_ORIGIN_SHARE_PLACEHOLDER}
          disabled={isDisabled}
          onFocus={() => {
            fetchData({
              'input-field': RawMaterialProps.QUANTITY,
            });
          }}
        />
      </div>
      <div className={styles.smallFieldContainer}>
        <InputField
          key={FieldProps.INGREDIENT_UNIT}
          name={`${RawMaterialProps.INGREDIENTS}[${index}].${RawMaterialProps.ORIGINS}[${originIndex}].${RawMaterialProps.PERCENTAGE}`}
          label={FieldProps.INGREDIENT_UNIT_PLACEHOLDER}
          placeholderstring={FieldProps.INGREDIENT_UNIT_PLACEHOLDER}
          disabled={true}
        />
      </div>
      {!isDisabled && (
        <div
          className={styles.deleteButton}
          onClick={() =>
            handleRemoveOrigins(
              formikProps,
              index,
              originIndex,
              RawMaterialProps.INGREDIENT
            )
          }>
          <DeleteButton
            className={clsx(
              hasErrorAndTouched(
                formikProps.errors.ingredients?.[index],
                formikProps.touched.ingredients?.[index],
                styles
              )
            )}
          />
        </div>
      )}
    </div>
  );
};

export default IngredientOriginFields;
